import React from "react"
import ConfirmButton from "./ConfirmButton";
import CancelButton from "./CancelButton";

function ConfirmAndCancel(props) {
    return (
        <div className="row mt-5">
            <div className="col-md-6 mb-2 mb-md-0">
                <CancelButton onClick={props.onCancel}>{props.cancelText || "Cancel"}</CancelButton>
            </div>
            <div className="col-md-6">
                <ConfirmButton onClick={props.onConfirm}>{props.confirmText || "Confirm"}</ConfirmButton>
            </div>
        </div>
    )
}

export default ConfirmAndCancel;